import { SerializedConstructor } from '@langchain/core/load/serializable';

import { SUPPORTED_RUNNABLES } from './Playground.constants';

function validatePromptTemplate(
  manifest: SerializedConstructor
): string | undefined {
  // validate PromptTemplate
  if (!manifest?.kwargs) {
    return `PromptTemplate did not have kwargs`;
  }
  // needs template and input_variables
  if (!manifest.kwargs.template) {
    return `PromptTemplate did not have template`;
  }
  if (!manifest.kwargs.input_variables) {
    return `PromptTemplate did not have input_variables`;
  }
  if (!manifest.kwargs.template_format) {
    return `PromptTemplate did not have template_format`;
  }
  if (
    'partial_variables' in manifest.kwargs &&
    Object.keys(manifest.kwargs.partial_variables).length
  ) {
    return `PromptTemplate had partial_variables`;
  }
}

function validateChatPromptTemplate(
  manifest: SerializedConstructor
): string | undefined {
  // validate ChatPromptTemplate
  // mirrors convertMessages logic from ManifestChatPromptTemplate
  if (!manifest?.kwargs) {
    return `ChatPromptTemplate did not have kwargs`;
  }
  if (!('messages' in manifest.kwargs)) {
    return `ChatPromptTemplate did not have messages`;
  }

  for (const [i, value] of manifest.kwargs.messages.entries()) {
    if (!value?.kwargs) {
      return `Message ${i} did not have kwargs`;
    }
    // MessagePlaceholder
    if ('variable_name' in value.kwargs) {
      return;
    }

    // PromptTemplates
    if ('prompt' in value.kwargs) {
      const prompt = Array.isArray(value.kwargs.prompt)
        ? value.kwargs.prompt
        : [value.kwargs.prompt];

      if (prompt.some((i) => i?.kwargs?.template == null)) {
        return 'PromptTemplate did not have template';
      }
    }

    if ('messages' in value.kwargs) {
      return `Message ${i} had nested messages`;
    }
  }
}

const VALIDATORS = {
  'langchain/prompts/prompt/PromptTemplate': validatePromptTemplate,
  'langchain/prompts/chat/ChatPromptTemplate': validateChatPromptTemplate,
  'langchain_core/prompts/prompt/PromptTemplate': validatePromptTemplate,
  'langchain_core/prompts/chat/ChatPromptTemplate': validateChatPromptTemplate,
};

export function validateManifest(
  manifest: SerializedConstructor
): string | undefined {
  const type = manifest.id.join('/');
  const typeName = manifest.id.at(-1);
  if (
    !SUPPORTED_RUNNABLES.map((c) => [...c.items, ...(c.hiddenItems ?? [])])
      .flat()
      .includes(type)
  ) {
    // not a supported runnable
    return `Type ${typeName} is not supported in the Playground`;
  }
  const validator = VALIDATORS[type];
  if (validator) {
    return validator(manifest);
  }

  // else it passes
}
